import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { ObjectManager } from '../../../concepts/objects';
import { Point } from '../../../platform/geom/Point';
import { Camera } from '../../canvas/Camera';
import { EditorSession } from '../../canvas/EditorSession';
import { Root } from '../../canvas/entities/Root';
import { RootOverride } from '../../canvas/RootOverride';
import { Reaction } from './Reaction';
import { ReactionIcon } from './ReactionIcon';

export const createReaction = defineCommand(
    'createReaction',
    'Reactions: Create',
    (cc, [input]: [{ emoji: string, at: Point }?] = []) => {

        const camera = cc.call(Camera);
        const objects = cc.call(ObjectManager);
        const session = cc.call(EditorSession);

        const root = session.get(RootOverride) ?? objects.get('root', Root);
        const ncp = root.toRelative(camera.position.round(0)).round();

        objects.update(u => {

            const ri = u.create(ReactionIcon);
            root.add(ri);
            ri.width = 40;
            ri.height = 40;
            ri.emoji = input?.emoji ?? '1f44d';
            if (input?.at) {
                const to = Point.from(input.at).subtract(ri.size().divide(2));
                ri.moveTo(to);
            }
            else {
                ri.moveTo(ncp.subtract(ri.size().divide(2)));
            }

        });
    }
);

export const clearReactions = defineCommand(
    'clearReactions',
    'Reactions: Clear',
    r => {
        const objects = r.call(ObjectManager);
        const all = objects.getAll(Reaction);

        objects.update(u => {
            for (const x of all) {
                x.removeSelf();
                u.delete(x);
            }
        });
    }
);
